export enum GuideOption {
  Edit = 'Edit',
  Tags = 'Tags',
  Delete = 'Delete',
  MarkAsPrivate = 'MarkAsPrivate',
  MarkAsPublic = 'MarkAsPublic',
}
